import { TrendingUp, Film, UploadCloud, Flame } from "lucide-react";

const items = [
  {
    key: "trends_today",
    label: "Tendances aujourd'hui",
    icon: TrendingUp,
    color: "#1877f2",
    unit: "détectées",
  },
  {
    key: "videos_this_month",
    label: "Vidéos générées",
    icon: Film,
    color: "#f59e0b",
    unit: "ce mois-ci",
  },
  {
    key: "videos_ready",
    label: "Prêtes à publier",
    icon: UploadCloud,
    color: "#60a5fa",
    unit: "en file",
  },
  {
    key: "engagement_estimate_pct",
    label: "Engagement estimé",
    icon: Flame,
    color: "#22c55e",
    unit: "comm.+partages / likes · 7 j",
    suffix: "%",
  },
];

function Sparkline({ data = [], color = "#1877f2" }) {
  if (!data.length) return null;
  const max = Math.max(1, ...data);
  const w = 90, h = 28;
  const step = w / Math.max(1, data.length - 1);
  const points = data
    .map((v, i) => `${i * step},${h - (v / max) * h}`)
    .join(" ");
  return (
    <svg viewBox={`0 0 ${w} ${h}`} className="w-[90px] h-7">
      <polyline fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" points={points} />
      <polyline
        fill={`${color}22`}
        stroke="none"
        points={`0,${h} ${points} ${w},${h}`}
      />
    </svg>
  );
}

export default function KpiBar({ stats, loading }) {
  return (
    <section
      className="grid grid-cols-2 lg:grid-cols-4 gap-4"
      data-testid="kpi-bar"
    >
      {items.map((it, idx) => {
        const Icon = it.icon;
        const raw = stats?.[it.key];
        const value = raw ?? 0;
        return (
          <div
            key={it.key}
            className="card-surface p-5 fade-up"
            style={{ animationDelay: `${idx * 60}ms` }}
            data-testid={`kpi-${it.key}`}
          >
            <div className="flex items-start justify-between">
              <div>
                <div className="text-[11px] font-mono-ui tracking-widest text-[color:var(--bcs-text-dim)] uppercase">
                  {it.label}
                </div>
                <div className="mt-3 flex items-baseline gap-1">
                  <span className="font-display text-3xl lg:text-4xl font-bold tabular-nums">
                    {loading ? "—" : value}
                    {it.suffix || ""}
                  </span>
                </div>
                <div className="text-xs text-[color:var(--bcs-text-mut)] mt-1">{it.unit}</div>
              </div>
              <div
                className="w-9 h-9 rounded-lg flex items-center justify-center"
                style={{ background: `${it.color}18`, color: it.color }}
              >
                <Icon className="w-4.5 h-4.5" strokeWidth={2.2} />
              </div>
            </div>
            {it.key === "trends_today" && (
              <div className="mt-4">
                <Sparkline data={stats?.sparkline || []} color={it.color} />
                <div className="text-[10px] font-mono-ui text-[color:var(--bcs-text-dim)] mt-1">
                  7 DERNIERS JOURS
                </div>
              </div>
            )}
            {it.key === "videos_this_month" && stats?.model_breakdown && (
              <div className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-1 text-[10.5px] font-mono-ui text-[color:var(--bcs-text-mut)]">
                <span>MONTAGE {stats.model_breakdown.montage || 0}</span>
                <span>·</span>
                <span>RÉSUMÉ {stats.model_breakdown.digest || 0}</span>
                <span>·</span>
                <span>IA {(stats.model_breakdown.veo3 || 0) + (stats.model_breakdown.kling || 0) + (stats.model_breakdown.seedance || 0)}</span>
              </div>
            )}
          </div>
        );
      })}
    </section>
  );
}
